<template>
  <section v-if="article" class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Update Article</p>
      <b-button type="is-danger" icon-left="delete" @click="deleteArticle"
        >Delete Article</b-button
      >
    </header>

    <section class="modal-card-body">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <div class="margin">
          <b-notification
            @close="resetErrors"
            :active="updateArticleErrors != null"
            type="is-danger"
            has-icon
            aria-close-label="Close notification"
            role="alert"
          >
            {{ updateArticleErrors }}
          </b-notification>
          <item-title
            :title="article.title"
            :itemType="'article'"
            :displaySuccess="false"
            @updateTitle="localArticle.title = $event"
          />

          <b-field>
            <template slot="label">
              Subtitle
              <b-tooltip
                position="is-right"
                type="is-dark"
                multilined
                size="is-small"
                label="Subtitle of the Article"
              >
                <b-icon
                  size="is-small"
                  type="is-gray"
                  icon="help-circle-outline"
                ></b-icon>
              </b-tooltip>
            </template>
            <b-input
              placeholder="e.g. Tips & tricks to enjoy the convention"
              v-model="localArticle.subtitle"
              maxlength="100"
            ></b-input>
          </b-field>

          <item-word
            :word="article.starting_word"
            :wordPosition="'Starting'"
            :itemType="'article'"
            @updateWord="localArticle.starting_word = $event"
          />

          <item-word
            :word="article.ending_word"
            :wordPosition="'Ending'"
            :itemType="'article'"
            @updateWord="localArticle.ending_word = $event"
          />

          <item-languages
            :languages="article.language_list"
            :maxTags="'1'"
            @updateLanguages="localArticle.language_list = $event"
          />

          <b-field>
            <template slot="label">
              Topic
              <b-tooltip
                position="is-right"
                type="is-dark"
                multilined
                size="is-small"
                label="Topic of the Article"
              >
                <b-icon
                  size="is-small"
                  type="is-gray"
                  icon="help-circle-outline"
                ></b-icon>
              </b-tooltip>
            </template>
            <b-select
              placeholder="Select a topic"
              v-model="localArticle.article_topic_id"
            >
              <option v-for="topic in articleTopics" :value="topic.id" :key="topic.id">
                {{ topic.attributes.name }}
              </option>
            </b-select>
          </b-field>
          <item-video :video="article.video" @updateVideo="localArticle.video = $event" />

          <item-tags
            :tags="article.tag_list"
            :placeholder="'WCS, Comic Con, Photoshop...'"
            @updateTags="localArticle.tag_list = $event"
          />
          <item-visibility
            :hidden="article.hidden"
            :itemType="'article'"
            @updateHidden="localArticle.hidden = $event"
          />
        </div>
      </ValidationObserver>
    </section>

    <footer class="modal-card-foot">
      <b-button class="button" type="button" @click="$parent.close()">Close</b-button>
      <b-button type="is-primary" @click="updateArticle">Update</b-button>
    </footer>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationObserver } from 'vee-validate'

// Attributes
import ItemTitle from '@/components/Attributes/ItemTitle'

import ItemLanguages from '@/components/Attributes/ItemLanguages'
import ItemVideo from '@/components/Attributes/ItemVideo'
import ItemTags from '@/components/Attributes/ItemTags'
import ItemVisibility from '@/components/Attributes/ItemVisibility'
import ItemWord from '@/components/Attributes/ItemWord'

export default {
  props: ['article'],
  components: {
    ValidationObserver,
    ItemTitle,
    ItemLanguages,
    ItemVideo,
    ItemTags,
    ItemVisibility,
    ItemWord
  },
  data () {
    return {
      localArticle: {
        title: null,
        subtitle: null,
        tag_list: [],
        article_topic_id: null,
        hidden: false,
        starting_word: null,
        ending_word: null,
        language_list: [],
        video: null
      },
      articleTopics: null,
      updateArticleErrors: null,
      filteredLanguages: this.getLanguageNames
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  methods: {
    resetErrors () {
      this.updateArticleErrors = null
    },
    updateArticle () {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.$store
            .dispatch('articles/update', {
              article: this.article.id,
              payload: this.localArticle
            })
            .then((resp) => {
              this.$emit('updatedArticle', resp.data.data.attributes)
              this.$parent.close()
            })
            .catch((error) => {
              // TODO: Handle
              console.log(error.response.data)
            })
        }
      })
    },

    deleteArticle () {
      this.$buefy.dialog.confirm({
        title: 'Deleting article',
        message:
          'Are you sure you want to <b>delete</b> your article? This action cannot be undone.',
        confirmText: 'Delete Article',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store
            .dispatch('articles/destroy', this.article.id)
            .then((resp) => {
              this.$router.push(`/users/${this.currentUser.attributes.username}`)
              this.$buefy.toast.open('Article deleted!')
            })
            .catch((err) => {
              console.log(err)
              this.$buefy.toast.open('Article could not be deleted')
            })
        }
      })
    }
  },
  created () {
    this.$store
      .dispatch('articleTopics/index')
      .then((response) => {
        this.articleTopics = response.data.data
        this.localArticle.title = this.article.title
        this.localArticle.subtitle = this.article.subtitle
        this.localArticle.tag_list = this.article.tag_list
        this.localArticle.hidden = this.article.hidden
        this.localArticle.starting_word = this.article.starting_word
        this.localArticle.ending_word = this.article.ending_word
        this.localArticle.article_topic_id = this.article.article_topic_id
        this.localArticle.language_list = this.article.language_list
        this.localArticle.video = this.article.video
      })
      .catch((error) => {
        console.log(error.response)
      })
  }
}
</script>

<style lang="scss" scoped>
.margin {
  margin: 0rem 1rem;
}
</style>
